import {graphql} from 'react-relay'
import {useFragment} from 'react-relay/hooks'

import {LABELS} from '../constants/labels'
import type {IssueFieldRemovedEvent$key} from './__generated__/IssueFieldRemovedEvent.graphql'
import {IssueFieldEvent, type IssueFieldEventBaseProps} from './IssueFieldEvent'

type IssueFieldRemovedEventProps = IssueFieldEventBaseProps & {
  queryRef: IssueFieldRemovedEvent$key & {createdAt?: string}
}

// eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-queries
const IssueFieldRemovedEventFragment = graphql`
  fragment IssueFieldRemovedEvent on IssueFieldRemovedEvent {
    databaseId
    actor {
      # eslint-disable-next-line relay/must-colocate-fragment-spreads
      ...TimelineRowEventActor
    }
    createdAt
    issueField {
      ... on IssueFieldText {
        dataType
        name
      }
      ... on IssueFieldDate {
        name
        dataType
      }
      ... on IssueFieldNumber {
        name
        dataType
      }
      ... on IssueFieldSingleSelect {
        name
        dataType
      }
    }
  }
`

export function IssueFieldRemovedEvent({queryRef, ...props}: IssueFieldRemovedEventProps) {
  const {actor, createdAt, issueField, databaseId} = useFragment(IssueFieldRemovedEventFragment, queryRef)
  return (
    <IssueFieldEvent
      actor={actor}
      createdAt={createdAt}
      fieldName={issueField?.name}
      dataType={issueField?.dataType}
      databaseId={databaseId}
      leadingLabel={LABELS.timeline.issueFieldRemoved.leading}
      hasValue={false}
      {...props}
    />
  )
}

try{ IssueFieldRemovedEvent.displayName ||= 'IssueFieldRemovedEvent' } catch {}